import { Flex, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay } from '@chakra-ui/react';
import ZaraButton from '../custom-components/buttons/Button';

const DeleteTransferrCall = ({ isOpen, onClose, onDeleteNumber, isLoading }) => {
    return (
        <Modal motionPreset='slideInBottom' isCentered isOpen={isOpen} onClose={onClose}>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Delete this phone number?</ModalHeader>
                <ModalBody>
                    <Flex justifyContent='space-between'>
                        <ZaraButton variant='secondary' onClick={onClose}>
                            Close
                        </ZaraButton>
                        <ZaraButton isLoading={isLoading} onClick={onDeleteNumber}>
                            Confirm
                        </ZaraButton>
                    </Flex>
                </ModalBody>
            </ModalContent>
        </Modal>
    );
};

export default DeleteTransferrCall;
